import React from 'react';
import PropTypes from 'prop-types';

import { DocumentActions } from '../../reflux/document_store';
import DocumentHelper from '../../helpers/document_helper';

import { GridFormStore } from 'grid_form/reflux/grid_form_store';

const DownloadDocumentButton = (props) => {
	let permissionDigitalSigned = props.pdfSigned;
	let mobile = props.isMobile;
	let visibleSigned = true;

	const storeItem = GridFormStore.store[props.gridId];

	if (storeItem && storeItem.propsRows && props.tableRowData && storeItem.propsRows[props.tableRowData.id] && storeItem.propsRows[props.tableRowData.id].visibleSigned === false)
		visibleSigned = storeItem.propsRows[props.tableRowData.id].visibleSigned;

	return (
		<div style={{display: 'flex'}}>
			{(permissionDigitalSigned == true && mobile !== true && visibleSigned === true) ?
				<a id="anchor-digital-signature" className="tooltipped" data-position="top" data-delay="10" data-tooltip="Assinatura Digital" style={{marginRight: '6px', cursor: 'pointer'}} onClick={() => { digitalSignature(props) }}>
					<svg className='icon-certificate-digital' xmlns="http://www.w3.org/2000/svg" fill="#343434" width="24" height="24" viewBox="0 0 24 24">
						<path d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"/>
						<path d="M0 0h24v24H0z" fill="none"/>
					</svg>
				</a>
			: ''}
			<a className="table-cell__content" href="#" onClick={(event) => downloadDocument(event, props)}>
				{ DocumentHelper.getFileNameFromDocumentValue(props.value) }
			</a>
		</div>
	);
};

const downloadDocument = (event, props) => {
	event.preventDefault();
	DocumentActions.downloadDocumentFile(props.name, DocumentHelper.parseDocumentValue(props.value));
};

const digitalSignature = (props) => {
	const value = props.value;
	let valueSplit = value.split(':');
	let fileName = valueSplit[0];
	let fileUUID = valueSplit[1];

	const inputDocumentValue = {
		fileName: fileName || '',
		fileUUID: fileUUID || ''
	};

	DocumentActions.openDigitalSignature(props.name, inputDocumentValue);
}

DownloadDocumentButton.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	pdfSigned: PropTypes.string.isRequired,
	isMobile: PropTypes.string.isRequired
};

export default DownloadDocumentButton;
